export interface UserBuildingApartment {
  id: string;
  name: string;
  code: string;
  role: string;
}

export interface UserBuilding {
  id: string;
  name: string;
  apartments: UserBuildingApartment[];
}

export type UserPrivacySettings = {
  /**
   * Without this accepted, the user can't use the application.
   */
  basicPolicyAccepted: boolean;
  /**
   * Prevents user that didn't flag this to receive the communications that are
   * targeted as marketing.
   */
  newsletterAccepted: boolean;
  /**
   * Allows the user to reserve external services.
   */
  thirdPartyDataTransmissionAccepted: boolean;
  /**
   * This will be used in the future, apparently.
   */
  userPersonalDataTransmissionAccepted: boolean;
  /**
   * Holds the last date those preferences were updated.
   */
  lastUpdate: string;
};

export interface User {
  id: string;
  username: string;
  firstName: string;
  lastName: string;
  role: string;
  email: string;
  status: string;
  phone: string;
  buildings: UserBuilding[];
  passwordChangeRequired?: boolean;
  language?: string;
  latestUserPrivacySettings?: UserPrivacySettings;
  lastTokenCheckedDate?: Date;
  isTestAccount?: boolean;
}

export type UserDevice = {
  id: string;
  userId: string;
  platform: "android" | "ios";
  deviceUid: string;
  deviceInfo: string;
  currentVersion: string;
  createdAt: number;
  updatedAt: number;
};

export function computeUserVisualName(user: User) {
  return `${user.lastName} ${user.firstName}`;
}
